import { getColumnDropDownOptionsProps, validateColumnInitValueProps } from '../../../../@types/TemplateOperators';
import { HeaderOption } from '../../TemplateEntity';

export const getColumnDropDownOptions: getColumnDropDownOptionsProps = (dropDownOptions) => {
  return dropDownOptions.map(({ label, value }: HeaderOption) => ({
    label,
    value: value[0].args[0]
  }));
};

export const validateColumnInitValue: validateColumnInitValueProps = (columnNumber, optionsLength) => {
  return columnNumber && columnNumber <= optionsLength ? columnNumber : null;
};
